<template lang="">
  <div id="explain-area">
    <div class="explain-are-content">
      <h2>{{$t(`message.funText.title`)}}</h2>
      <ul class="flexible flex-wrap">
        <li class="cell">
          <img v-lazy="imgList[0].src" alt="" />
          <h3>{{$t(`message.funText.h3[0]`)}}</h3>
          <p>
            {{$t(`message.funText.p[0]`)}}
          </p>
        </li>
        <li class="cell">
          <img v-lazy="imgList[1].src" alt="" />
          <h3>{{$t(`message.funText.h3[1]`)}}</h3>
          <p>{{$t(`message.funText.p[1]`)}}</p>
        </li>
        <li class="cell" style="margin-right: 0;">
          <img v-lazy="imgList[2].src" alt="" />
          <h3>{{$t(`message.funText.h3[2]`)}}</h3>
          <p>{{$t(`message.funText.p[2]`)}} </p>
        </li>
        <li class="cell">
          <img v-lazy="imgList[3].src" alt="" />
          <h3>{{$t(`message.funText.h3[3]`)}}</h3>
          <p>
            {{$t(`message.funText.p[3]`)}}
          </p>
        </li>
        <li class="cell">
          <img v-lazy="imgList[4].src" alt="" />
          <h3>{{$t(`message.funText.h3[4]`)}}</h3>
          <p>{{$t(`message.funText.p[4]`)}}</p>
        </li>
        <li class="cell" style="margin-right: 0;">
          <img v-lazy="imgList[5].src" alt="" />
          <h3>{{$t(`message.funText.h3[5]`)}}</h3>
          <p>{{$t(`message.funText.p[5]`)}}</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        footType: '',
        imgList: [
          {
            src: require("../assets/explain/pdf-toolset.png")
          },
          {
            src: require("../assets/explain/document-excellent.png")
          },
          {
            src: require("../assets/explain/easy-use.png")
          },
          {
            src: require("../assets/explain/reliable-safe.png")
          },
          {
            src: require("../assets/explain/strong-app.png")
          },
          {
            src: require("../assets/explain/customer-satisfaction.png")
          },
        ]
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.footType = this.$store.state.local
      })
    },
  }
</script>
<style lang="scss" scoped>
  #explain-area {
    padding: 128px 0;
    height: 851px;
    /* background: url('../assets/explain/background.jpg'); */
    background: url('data:image/svg+xml;base64,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');
    background-size: cover;

    .explain-are-content {
      max-width: 1224px;
      margin: 0 auto;

      h2 {
        font-style: normal;
        font-weight: 800;
        font-size: 56px;

        text-align: center;

        color: #3D454D;
      }

      .cell {
        max-width: 365px;
        margin-top: 80px;
        text-align: left;
        margin-right: 64px;

        h3 {
          font-size: 20px;
          font-weight: 700;
          color: #3D454D;
          margin-top: 16px;
        }

        p {
          text-align: left;
          margin-top: 8px;
          color: #667280;
          font-size: 14px;
        }

        img {
          width: 72px;
          height: 72px
        }
      }
    }
  }
</style>